import $ from 'jquery';
import rivets from 'rivets';
import BaseView from '../../core/baseView';
import InputsetB2bCompanyModel from '../../layout/b2b/inputsetB2bCompanyModel';
import InputsetB2bCompanyView from '../../layout/b2b/inputsetB2bCompanyView';
import AddressCheckViewController from '../../helpers/addressCheck/addressCheckViewController';
import ItalianTaxId from '../../layout/italianTaxId';
import PhoneNumberFormatter from '../../layout/phoneNumberFormatterView';

export default BaseView.extend({
  initialize: function() {
    new InputsetB2bCompanyView({
      el: $('.js-inputset-b2b-company')[0],
      model: new InputsetB2bCompanyModel()
    });

    new PhoneNumberFormatter({
      el: $('[name="telephone"]')
    });

    new AddressCheckViewController({
      el: $('form.myaccount-address'),
      scope: $('body')
    });

    this.$taxId = $('.js-tax-id input');

    if (this.$taxId.length) {
      new ItalianTaxId({
        el: this.$taxId
      });
    }

    this.setupRivetsBindings();
    this.bindEvents();
  },

  bindEvents: function() {
    if (this.$taxId.length) {
      this.listenTo(this.model, 'change:showTaxId', this.onShowTaxId, this);
    }
  },

  setupRivetsBindings: function() {
    rivets.bind(this.$el, {
      viewModel: this.model
    });
  },

  onShowTaxId: function(model, value) {
    if (this.$taxId) {
      this.$taxId.attr('data-validate', value);
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/checkout/checkoutAddressView.js
 **/